<inthraction-objective-response-distribution [mode]="mode" [employee]="employee"></inthraction-objective-response-distribution>
